import React, { useState } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import styles from "./RegistrarCuenta.module.css";
import { useNavigate } from "react-router-dom";
import sideImage from "../../src/assets/img/login/sky-home.svg";
import logo from "../assets/img/logos/sky-new-2020-seeklogo2.svg";
import BarraLoader from "../General/BarraLoader";
import ConfirmMessage from "../General/ConfirmMessage";

export const RegistroExitoso: React.FC = () => {
  const [codigo, setCodigo] = useState<string[]>(["", "", "", ""]);
  const [statusError, setStatusError] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [imagenURI] = useState(logo);
  const [status, setStatus] = useState({
    show: false,
    color: "red",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async () => {};

  return (
    <>
      <Container className={styles.container}>
        <div className={styles["confirmMessage"]}>
          <ConfirmMessage
            status={statusError}
            message={message}
            showAlert={showAlert}
          />
        </div>

        {loading && <BarraLoader />}

        <Row className={styles["rowContainer"]}>
          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            className={styles["registrarForm"]}
          >
            <Form className={styles.estiloForm}>
              <img src={imagenURI} className={styles.logo} alt="Logo" />
              <hr className={styles["line"]} />

              <Row>
                <h4
                  className={
                    "text-2xl text-center " + styles["textGradient"] + " mb-2"
                  }
                >
                  <span>Registro</span>
                </h4>
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.5 28.621L11 21.1195L13.1195 19L18.5 24.379L29.8775 13L32 15.1225L18.5 28.621Z"
                    fill="#198038"
                  />
                  <path
                    d="M21 0C16.8466 0 12.7865 1.23163 9.33303 3.53914C5.8796 5.84665 3.18798 9.1264 1.59854 12.9636C0.00909895 16.8009 -0.406771 21.0233 0.403519 25.0969C1.21381 29.1705 3.21386 32.9123 6.15077 35.8492C9.08767 38.7861 12.8295 40.7862 16.9031 41.5965C20.9767 42.4068 25.1991 41.9909 29.0364 40.4015C32.8736 38.812 36.1534 36.1204 38.4609 32.667C40.7684 29.2135 42 25.1534 42 21C42 15.4305 39.7875 10.089 35.8493 6.15076C31.911 2.21249 26.5696 0 21 0ZM21 39C17.4399 39 13.9598 37.9443 10.9997 35.9665C8.03966 33.9886 5.73256 31.1774 4.37018 27.8883C3.0078 24.5992 2.65134 20.98 3.34587 17.4884C4.04041 13.9967 5.75474 10.7894 8.27209 8.27208C10.7894 5.75473 13.9967 4.0404 17.4884 3.34586C20.98 2.65133 24.5992 3.00779 27.8883 4.37017C31.1774 5.73255 33.9886 8.03965 35.9665 10.9997C37.9443 13.9598 39 17.4399 39 21C39 25.7739 37.1036 30.3523 33.7279 33.7279C30.3523 37.1036 25.7739 39 21 39Z"
                    fill="#198038"
                  />
                </svg>
              </Row>

              {/* Código de verificación */}
              <Row className="justify-content-center">
                <Col md={12} className="text-center">
                  <br></br>
                  <p>
                    Revisa tu correo electrónico para continuar <br></br> con la
                    activacion de la cuenta
                  </p>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            className={styles["imageContainer"]}
          >
            <img src={sideImage} className={styles["sideImage"]} alt="Side" />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RegistroExitoso;
